import { all, call, put, takeLatest } from "redux-saga/effects";
import { AxiosCall, AxiosPost, AxiosPatch, AxiosDelete, AxiosFile } from "../../../utils/axios";
import * as actions from "./monitoringActions";

// ==================== MONITORING RECORDS ====================

function* fetchMonitoringRecords(action) {
    try {
        const { batchId } = action.payload;
        const result = yield call(AxiosCall, `/mycore/record/list/?batch_id=${batchId}`);
        yield put(actions.fetchMonitoringRecordsSuccess(result.data));
    } catch (e) {
        yield put(actions.fetchMonitoringRecordsFailure(e.message));
    }
}

function* fetchMonitoringSummary(action) {
    try {
        const { batchId } = action.payload;
        const result = yield call(AxiosCall, `/mycore/record/summary/?batch_id=${batchId}`);
        yield put(actions.fetchMonitoringSummarySuccess(result.data));
    } catch (e) {
        yield put(actions.fetchMonitoringSummaryFailure(e.message));
    }
}

function* fetchMonitoringDetail(action) {
    try {
        const { recordId } = action.payload;
        const result = yield call(AxiosCall, `/mycore/${recordId}/record/detail/`);
        yield put(actions.fetchMonitoringDetailSuccess(result.data));
    } catch (e) {
        yield put(actions.fetchMonitoringDetailFailure(e.message));
    }
}

// ==================== CREATE/UPDATE/DELETE ====================

function* createMonitoringRecord(action) {
    try {
        // Check if there's an image in the payload
        const hasImage = action.payload.image && action.payload.image instanceof File;

        if (hasImage) {
            // Use FormData for file upload
            const formData = new FormData();
            Object.keys(action.payload).forEach(key => {
                if (action.payload[key] !== null && action.payload[key] !== undefined) {
                    formData.append(key, action.payload[key]);
                }
            });
            const result = yield call(AxiosFile, '/mycore/record/add/', formData);
            yield put(actions.createMonitoringRecordSuccess(result.data));
        } else {
            // Use JSON for simple data
            const result = yield call(AxiosPost, '/mycore/record/add/', action.payload);
            yield put(actions.createMonitoringRecordSuccess(result.data));
        }

        // Refresh the list
        yield put(actions.fetchMonitoringRecordsRequest(action.payload.batch));
        yield put(actions.fetchMonitoringSummaryRequest(action.payload.batch));
    } catch (e) {
        yield put(actions.createMonitoringRecordFailure(e.message));
    }
}

function* updateMonitoringRecord(action) {
    try {
        const { recordId, recordData } = action.payload;
        const hasImage = recordData.image && recordData.image instanceof File;

        if (hasImage) {
            // Use FormData for file upload
            const formData = new FormData();
            Object.keys(recordData).forEach(key => {
                if (recordData[key] !== null && recordData[key] !== undefined) {
                    formData.append(key, recordData[key]);
                }
            });
            const result = yield call(AxiosFile, `/mycore/${recordId}/record/update/`, formData);
            yield put(actions.updateMonitoringRecordSuccess(result.data));
        } else {
            // Use JSON for simple data
            const result = yield call(AxiosPatch, `/mycore/${recordId}/record/update/`, recordData);
            yield put(actions.updateMonitoringRecordSuccess(result.data));
        }

        // Refresh summary
        if (recordData.batch) {
            yield put(actions.fetchMonitoringSummaryRequest(recordData.batch));
        }
    } catch (e) {
        yield put(actions.updateMonitoringRecordFailure(e.message));
    }
}

function* deleteMonitoringRecord(action) {
    try {
        const { recordId } = action.payload;
        yield call(AxiosDelete, `/mycore/${recordId}/record/delete/`);
        yield put(actions.deleteMonitoringRecordSuccess(recordId));
    } catch (e) {
        yield put(actions.deleteMonitoringRecordFailure(e.message));
    }
}

// ==================== ROOT SAGA ====================

export default function* monitoringSaga() {
    yield all([
        takeLatest(actions.FETCH_MONITORING_RECORDS.REQUEST, fetchMonitoringRecords),
        takeLatest(actions.FETCH_MONITORING_SUMMARY.REQUEST, fetchMonitoringSummary),
        takeLatest(actions.FETCH_MONITORING_DETAIL.REQUEST, fetchMonitoringDetail),
        takeLatest(actions.CREATE_MONITORING_RECORD.REQUEST, createMonitoringRecord),
        takeLatest(actions.UPDATE_MONITORING_RECORD.REQUEST, updateMonitoringRecord),
        takeLatest(actions.DELETE_MONITORING_RECORD.REQUEST, deleteMonitoringRecord),
    ]);
}
